import { render, staticRenderFns } from "./PromoAccordion.vue?vue&type=template&id=1a7e82af&scoped=true&"
import script from "./PromoAccordion.vue?vue&type=script&lang=js&"
export * from "./PromoAccordion.vue?vue&type=script&lang=js&"
import style0 from "./PromoAccordion.vue?vue&type=style&index=0&id=1a7e82af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7e82af",
  null
  
)

/* custom blocks */
import block0 from "@/locales/promo_accordion.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2F_shared%2FPromo%2FPromoAccordion.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports